<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "TechnicalOverview"
    }
</script>

<style scoped>

</style>
